(function () {
    'use strict';

    angular
        .module('app.shared')
        .component('sc3TabSet', {
            templateUrl: 'app/shared/tab-set/tab-set.component.html',
            controller: TabSetComponent,
            transclude: true
        });

    var $ = angular.element;

    TabSetComponent.$inject = ['$scope', '$element', 'mediaState'];
    function TabSetComponent($scope, $element, mediaState) {
        var ctrl = this;
        ctrl.view = null;
        ctrl.nav = null;
        Object.defineProperty(ctrl, 'isPhone', { get: getIsPhone });
        ctrl.$onInit = init;

        /////////////////////////////////////////////////////

        function init() {
            ctrl.view = $($element[0].querySelector('.ts-view'));
            ctrl.nav = $($element[0].querySelector('.ts-nav'));
            $scope.$watch('$ctrl.isPhone', phoneWatchAction);
            $scope.$watch(childNodeWatch, childNodeWatchAction);
        }

        function getIsPhone() {
            return mediaState.xs;
        }

        function phoneWatchAction(isPhone) {
            var view = ctrl.view;
            if (!isPhone && view.parent()[0] !== $element[0])
                $element.append(view.removeClass('ng-hide'));
        }

        function childNodeWatch() {
            return !!ctrl.nav.children().length;
        }

        function childNodeWatchAction(hasChildren) {
            var method = hasChildren ? 'removeAttr' : 'attr';
            ctrl.nav[method]('hidden', '');
        }
    }
})();